import {getClientConfig} from "@atg-shared/client-config";
import {decide, Flags} from "@atg-shared/feature-experimentation";
import atgRequst from "@atg-shared/fetch";
import {GAME_SERVICE_URL, RACE_SERVICE_URL} from "@atg-shared/service-url";

import type {HorseGame, HorseRaceExtended} from "@atg-tillsammans/game-types";

export const getGameEndpoint = (): string =>
    decide(Flags.HORSE_RACING_INFO_GAME).variationKey === "on"
        ? `${getClientConfig().horse.horse_betting_info_url}/v0/games`
        : `${GAME_SERVICE_URL}`;

export const getRaceEndpoint = (): string =>
    decide(Flags.HORSE_RACING_INFO_RACES_AND_POOLS).variationKey === "on"
        ? `${getClientConfig()?.horse.horse_betting_info_url}/v0/races`
        : `${RACE_SERVICE_URL}`;

export const fetchHorseGame = (gameId: string) =>
    atgRequst<HorseGame>(`${getGameEndpoint()}/${gameId}`);

export const fetchExtendedRace = (raceId: string) =>
    atgRequst<HorseRaceExtended>(`${getRaceEndpoint()}/${raceId}/extended`);
